import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { DeleteJobsModal } from 'components/modals/DeleteJobsModal/DeleteJobsModal'
import { ArchiveJobsModal } from 'components/modals/ArchiveJobsModal/ArchiveJobsModal'
import { ExportJobsModal } from 'components/modals/ExportJobsModal/ExportJobsModal'
import { PositionManagementModal } from 'components/modals/PositionManagementModal/PositionManagementModal'
import { PositionSelectionModal } from 'components/modals/PositionSelectionModal/PositionSelectionModal'
import { PositionTemplateModal } from 'components/modals/PositionTemplateModal/PositionTemplateModal'
import { SavePositionTemplateModal } from 'components/modals/SavePositionTemplateModal/SavePositionTemplateModal'
import { TemplateBasedJobPositionModal } from 'components/modals/TemplateBasedJobPositionModal/TemplateBasedJobPositionModal'
import { ActionsDropdown } from 'components/shared/ActionsDropdown/ActionsDropdown'
import { Button } from 'components/shared/Button/Button'
import { Pane } from 'components/shared/Pane/Pane'
import { SearchWidget } from 'components/shared/SearchWidget/SearchWidget'
import { JobsTable } from './common/JobsTable/JobsTable'
import { getFiltersConfigs } from './common/JobsTable/model'
import { FilterDropdown } from 'components/shared/FilterDropdown/FilterDropdown'
import { useProjects } from './hooks'

import { DepartmentFilter } from 'components/shared/DepartmentFilter/DepartmentFilter'
import { PlusCircleIcon } from 'components/shared/Icon/Icon'

import styles from './JobsListing.module.scss'

export const JobsListing = () => {
  const { state, handlers } = useProjects()

  const {
    actions,
    activeTemplate,
    project,
    search,
    filter,
    departmentValue,
    hasAnyTemplates,
    isCreatePositionModalOpen,
    isCreateTemplateModalOpen,
    isDeleteJobsModalOpen,
    isArchiveJobsModalOpen,
    isExportJobsModalOpen,
    isPositionTemplateModalOpen,
    isSaveTemplateModalOpen,
    isSelectionModalOpen,
  } = state
  const {
    handleCreatePositionOpen,
    handleCreateTemplateOpen,
    handleCreatePositionModalBack,
    handleCreatePositionModalClose,
    handleCreatePositionModalConfirm,
    handleCreateTemplateModalBack,
    handleCreateTemplateModalClose,
    handleCreateTemplateModalConfirm,
    handleDeleteJobsModalClose,
    handleDeleteJobsModalConfirm,
    handleArchiveJobsModalClose,
    handleArchiveJobsModalConfirm,
    handleExportJobsModalClose,
    handlePositionTemplateModalBack,
    handlePositionTemplateModalClose,
    handlePositionTemplateModalConfirm,
    handleSaveTemplateModalClose,
    handleSaveTemplateModalConfirm,
    handleSelectionModalClose,
    handleSelectionModalOpen,
    setActiveTemplate,
    setDepartment,
    setSearch,
    resetFilter,
    setFilter,
  } = handlers

  return (
    <>
      <Pane className={styles.jobs} tagName="article">
        <Pane.Header title={t`Jobs`} contentClassName={styles.headerContent}>
          <DepartmentFilter value={departmentValue} onChange={setDepartment} />
          <SearchWidget query={search} onChange={setSearch} />
          <FilterDropdown
            size="small"
            filter={filter}
            setFilter={setFilter}
            filtersConfig={getFiltersConfigs(['archived'])}
          />
          <Box align="center">
            <Button
              className={styles.button}
              color="primary"
              icon={PlusCircleIcon}
              label={t`Add job`}
              size="small"
              variant="filled"
              onClick={
                hasAnyTemplates
                  ? handleSelectionModalOpen
                  : handleCreatePositionOpen
              }
            />
            <ActionsDropdown size="small" {...{ actions }} />
          </Box>
        </Pane.Header>
        <JobsTable {...{ search, filter, resetFilter }} />
      </Pane>
      {hasAnyTemplates ? (
        <PositionSelectionModal
          onClose={handleSelectionModalClose}
          onCreateTemplate={handleCreateTemplateOpen}
          onFromScratch={handleCreatePositionOpen}
          isOpen={isSelectionModalOpen}
        />
      ) : null}
      <PositionTemplateModal
        onBack={handlePositionTemplateModalBack}
        onCancel={handlePositionTemplateModalClose}
        onClose={handlePositionTemplateModalClose}
        onConfirm={handlePositionTemplateModalConfirm}
        isOpen={isPositionTemplateModalOpen}
        {...{ activeTemplate, setActiveTemplate }}
      />
      <TemplateBasedJobPositionModal
        template={activeTemplate}
        onBack={handleCreateTemplateModalBack}
        onCancel={handleCreateTemplateModalClose}
        onClose={handleCreateTemplateModalClose}
        onConfirm={handleCreateTemplateModalConfirm}
        isOpen={isCreateTemplateModalOpen}
      />
      {isCreatePositionModalOpen ? (
        <PositionManagementModal
          onBack={handleCreatePositionModalBack}
          onCancel={handleCreatePositionModalClose}
          onClose={handleCreatePositionModalClose}
          onConfirm={handleCreatePositionModalConfirm}
          isOpen={isCreatePositionModalOpen}
          isStandalone={!hasAnyTemplates}
        />
      ) : null}
      <SavePositionTemplateModal
        onCancel={handleSaveTemplateModalClose}
        onClose={handleSaveTemplateModalClose}
        onConfirm={handleSaveTemplateModalConfirm}
        isOpen={isSaveTemplateModalOpen}
        {...{ project }}
      />
      <ExportJobsModal
        onCancel={handleExportJobsModalClose}
        onClose={handleExportJobsModalClose}
        isOpen={isExportJobsModalOpen}
      />
      <DeleteJobsModal
        onCancel={handleDeleteJobsModalClose}
        onClose={handleDeleteJobsModalClose}
        onConfirm={handleDeleteJobsModalConfirm}
        isOpen={isDeleteJobsModalOpen}
      />
      <ArchiveJobsModal
        onCancel={handleArchiveJobsModalClose}
        onClose={handleArchiveJobsModalClose}
        onConfirm={handleArchiveJobsModalConfirm}
        isOpen={isArchiveJobsModalOpen}
        archived={filter.archived}
      />
    </>
  )
}
